import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import $ from "jquery";
import { IsNumberKeyWithoutZero } from "./common";
import useAddToCart from "../../Context/hook/useAddtoCart";
import { useAuth } from "../../Context/AuthContext";

export const QuantityStripper = ({
  prd,
  params,
  showToaster = true,
  className = "",
  callbackfunction = null,
  inline = true,
  wrapperClass = "",
}) => {
  const [product, setProduct] = useState(null);
  const [productDetails, setProductDetails] = useState(null);
  const [qty, setQty] = useState(1);
  const [isAdded, setIsAdded] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const { handleAddtoCartLite, handleAddtoCartSimple } = useAddToCart();
  const prevState = useRef();
  const qtyRef = useRef(1);
  const { isBrowseOnly } = useAuth();

  useEffect(() => {
    if (
      prd &&
      (prevState.current == undefined || prevState.current.qty != prd.qty || prevState.current.prod_id != prd.prod_id)
    ) {
      prevState.current = prd;
      if (prd) setProduct(prd);
      const startQty = prd.qty > 0 ? prd.qty : 1;
      qtyRef.current = startQty;
      setQty(startQty);
    }
    setIsAdded(prd.qty > 0);
  }, [prd]);

  useEffect(() => {
    if (params) setProductDetails({ code: params?.code ?? "", desc: params?.desc ?? "", img: params?.img ?? "" });
    else setProductDetails(null);
  }, [params]);

  const debouncedFunction = useCallback(
    debounce(async (p, value, type) => {
      let result;
      if (showToaster)
        result = await handleAddtoCartLite(
          p,
          value,
          type,
          productDetails.desc,
          productDetails.img,
          productDetails.code,
        );
      else result = await handleAddtoCartSimple(p, value, type);
      if (result === false) {
        qtyRef.current = product.qty;
        setQty(product.qty);
      }
    }, 1000),
    [productDetails, product, showToaster],
  );

  const QuantityInc = () => {
    const currentqty = parseInt(qtyRef.current) + 1;
    qtyRef.current = currentqty;
    setQty(currentqty);
    if (isAdded) debouncedFunction(product.prod_id, currentqty, "INC");
  };

  const QuantityDec = () => {
    if (parseInt(qtyRef.current) > 1) {
      const currentqty = parseInt(qtyRef.current) - 1;
      qtyRef.current = currentqty;
      setQty(currentqty);
      if (isAdded) debouncedFunction(product.prod_id, currentqty, "DEC");
    }
  };

  const handleOnChange = (e) => {
    var value = IsNumberKeyWithoutZero(e.target.value);
    qtyRef.current = value;
    setQty(value);
    if (isAdded) debouncedFunction(product.prod_id, parseInt(value), "INC");
  };

  const handleAddtocartClick = async (event) => {
    const button = $(event.currentTarget);
    const addQty = parseInt(qtyRef.current) > 0 ? parseInt(qtyRef.current) : 1;
    qtyRef.current = addQty;
    setIsAdding(true);
    setQty(addQty);
    let result;
    if (showToaster)
      result = await handleAddtoCartLite(
        product.prod_id,
        addQty,
        "ADD",
        productDetails.desc,
        productDetails.img,
        productDetails.code,
      );
    else result = await handleAddtoCartSimple(product.prod_id, addQty, "ADD");
    window.addCartEffect(button);
    if (!result) setIsAdded(false);
    else setIsAdded(true);
    setIsAdding(false);
    if (callbackfunction && typeof callbackfunction === "function") callbackfunction(result);
  };

  const quantityControls = (
    <div className={inline ? "rowProduct-qty product-quantity" : "product-quantity"} key={product?.prod_id}>
      <div className={"qty-container " + className}>
        <button className="qty-btn-minus btn-light" type="button" aria-label="Decrease quantity" onClick={QuantityDec}>
          <i className="fa fa-minus" />
        </button>
        <input
          type="text"
          name="qty"
          value={qty}
          className="input-qty"
          aria-label="Quantity"
          onChange={handleOnChange}
        />
        <button className="qty-btn-plus btn-light" type="button" aria-label="Increase quantity" onClick={QuantityInc}>
          <i className="fa fa-plus" />
        </button>
      </div>
    </div>
  );

  const addToCartButton = (
    <div className={inline ? "product-button button-effect flex-fill" : "product-button button-effect"}>
      <button
        onClick={handleAddtocartClick}
        type="button"
        className={`btn btn-products btn-addcart addToCart${inline ? " px-1 text-nowrap" : ""}`}
        disabled={isAdding}
      >
        {isAdding ? (
          inline ? (
            <Fragment>
              <span className="fas fa-spinner fa-spin" />
              <span className="text-cta ms-1">Adding...</span>
            </Fragment>
          ) : (
            <Fragment>
              <span className="fas fa-spinner fa-spin me-1" /> Adding...
            </Fragment>
          )
        ) : inline ? (
          <Fragment>
            <span className="wes-cart" />
            <span className="text-cta">Add to Cart</span>
            <span className="text-only">Buy</span>
          </Fragment>
        ) : (
          <Fragment>
            <span className="wes-cart" /> Add to Cart
          </Fragment>
        )}
      </button>
    </div>
  );

  if (!product || isBrowseOnly) return null;

  if (!inline) {
    return <Fragment>{isAdded ? quantityControls : addToCartButton}</Fragment>;
  }

  return (
    <div
      className={`rowProduct-btns rowProduct-cart-inline variant-cart rowSuggest-item flex-wrap gap-1 ${wrapperClass}`.trim()}
    >
      {quantityControls}
      {addToCartButton}
    </div>
  );
};
